/* tslint:disable */

declare var Object: any;
export interface SFLeaveCancelRequestInterface {
  "id"?: number;
}

export class SFLeaveCancelRequest implements SFLeaveCancelRequestInterface {
  "id": number;
  constructor(data?: SFLeaveCancelRequestInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFLeaveCancelRequest`.
   */
  public static getModelName() {
    return "SFLeaveCancelRequest";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFLeaveCancelRequest for dynamic purposes.
  **/
  public static factory(data: SFLeaveCancelRequestInterface): SFLeaveCancelRequest{
    return new SFLeaveCancelRequest(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFLeaveCancelRequest',
      plural: 'SFLeaveCancelRequests',
      path: 'SFLeaveCancelRequests',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFLeaveCancelRequest.ts